import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import { MatchaAuto } from '@/components/MatchaAuto';

import { routes } from '@/utils/routes';

import { DEFAULT_SEO_CONFIG, ROOT_URL_PRODUCTION } from '../../next-seo.config';

const MATCHA_AUTO_TITLE = 'Matcha Auto';
const MATCHA_AUTO_DESCRIPTION = 'Gasless swaps, MEV savings and superior execution. Trade now.';

const MatchaAutoPage: NextPage = () => {
  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={MATCHA_AUTO_TITLE}
        description={MATCHA_AUTO_DESCRIPTION}
        canonical={`${ROOT_URL_PRODUCTION}${routes.MATCHA_AUTO}`}
        additionalMetaTags={[
          {
            name: 'twitter:title',
            content: MATCHA_AUTO_TITLE,
          },
          {
            name: 'twitter:description',
            content: MATCHA_AUTO_DESCRIPTION,
          },

          {
            name: 'twitter:url',
            content: `${ROOT_URL_PRODUCTION}${routes.MATCHA_AUTO}`,
          },
        ]}
      />
      <MatchaAuto />
    </>
  );
};

export default MatchaAutoPage;
